import { buildsServiceApi } from "../../api";

export const getObjectSettings = async ({
  projectId,
}: {
  projectId: string;
}): Promise<any> => {
  return buildsServiceApi
    .get<any>(`/projects/${projectId}/settings?idType=projectId`)
    .then((response) => response.data);
};
